const MainTitle = ({ title }) => {
  return (
    <div className='text-left md:text-3xl font-bold min-w-0 break-words'>{title}</div>
  )
}

export default MainTitle